import Image from 'next/image';
import Link from 'next/link';
import { withBasePath } from '@/utils/basePath';

const CURRENT_YEAR = new Date().getFullYear();

const Footer = () => {
  return (
    <footer className="max-width-white-section">
      <div className="max-width-white-section-content relative grid grid-cols-1 pb-28 lg:grid-cols-2">
        <div className="p-8">
          <h3 className="mb-8">Contact</h3>
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <p className="pb-4">
              Zele Solutions : <br />
              9, rue Angelique Verien <br />
              92200, Neuilly-sur-Seine
            </p>
            <div>
              <p>
                Tel :{' '}
                <a className="text-link" href="tel:330184257027">
                  01 84 25 70 27
                </a>
              </p>
              <p>
                Mail :{' '}
                <a className="text-link" href="mailto:info@zele-solutions.fr">
                  info@zele-solutions.fr
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="p-8">
          <h3 className="mb-8">zLawyer App</h3>
          <div className="flex flex-wrap">
            <a
              href="https://apps.apple.com/fr/app/zlawyer/id1174916635?mt=8"
              rel="noreferrer"
              target="_blank"
            >
              <Image
                alt="logo de telechargement vers l'Apple Store"
                className="mr-3 mb-3 w-40 cursor-pointer duration-150 hover:opacity-30"
                height={48}
                src={withBasePath('/images/logos/badgeAppStore.svg')}
                width={160}
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.zelesolution.zlawyer&hl=fr&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
              rel="noreferrer"
              target="_blank"
            >
              <Image
                alt="logo de telechargement vers le Play Store"
                className="mr-3 mb-3 w-40 cursor-pointer duration-150 hover:opacity-30"
                height={48}
                src={withBasePath('/images/logos/badgePlayStore.svg')}
                width={160}
              />
            </a>
          </div>
        </div>

        <div className="p-8">
          <h3 className="mb-8">Ressources</h3>
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="pb-4">
              <a
                className="text-link block"
                href="https://download.teamviewer.com/download/TeamViewerQS.exe"
                download
              >
                Assistance a distance (Teamviewer)
              </a>
              <a
                className="text-link block"
                href="https://anydesk.com/fr/downloads"
                rel="noreferrer"
                target="_blank"
              >
                Assistance a distance (Anydesk)
              </a>
              <p className="hidden">
                Ce fichier est l&apos;installateur officiel de zLawyer, un logiciel destine a la
                facturation pour avocat. Il necessite Windows et n&apos;altere aucun fichier systeme
                sans autorisation explicite.
              </p>
              <a
                className="text-link block"
                href={withBasePath('/download/zlawyerstp.exe')}
                rel="noopener noreferrer"
                download
              >
                Installation zLawyer
              </a>
            </div>

            <div>
              <Link
                className="text-link block"
                href="/conditions-generales-utilisation"
                scroll={false}
              >
                Conditions generales d&apos;utilisation
              </Link>
              <Link className="text-link block" href="/politques-de-confidentialite" scroll={false}>
                Politiques de confidentialite
              </Link>
              <Link className="text-link block" href="/politique-de-cookies" scroll={false}>
                Politiques de cookies
              </Link>
            </div>
          </div>
        </div>

        <div className="flex items-center p-8">
          <Image
            alt="panda"
            className="w-28"
            height={112}
            src={withBasePath('/images/pandas/panda.png')}
            width={112}
          />
        </div>

        <div className="absolute bottom-5 w-full">
          <p className="text-center">
            © 2006 - {CURRENT_YEAR} • Zele Solutions. Tous droits reserves.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
